import CloseIcon from '@mui/icons-material/Close'
import UnstyledDialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import UnstyledDialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import Slide from '@mui/material/Slide'
import React from 'react'
import styled from 'styled-components'

// Customized Components
const Dialog = styled(UnstyledDialog)`
  margin: 0 auto;

  .MuiPaper-root {
    align-self: flex-start;

    & > h2:first-of-type {
      padding: 16px 24px;
      font-size: 1.5em;
    }
    
  }
`

const DialogTitle = styled(UnstyledDialogTitle)`
  color: #4f2682;
`

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' unmountOnExit={true} ref={ref} {...props} />
})

export default ({
  title,
  open,
  handleClose,
  children,
  fullWidth = true,
  maxWidth = 600,
  className,
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      fullWidth={fullWidth}
      className={className}
      sx={{
        maxWidth: maxWidth,
      }}
      maxWidth={false}
    >
      <DialogTitle>
        <Grid container>
          <Grid item xs={11}>
            {title}
          </Grid>
          <Grid item xs={1}>
            <IconButton onClick={handleClose}>
              <CloseIcon sx={{ fontSize: '1.6em' }} />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
    </Dialog>
  )
}
